module.exports = __webpack_public_path__ + "img/rightcalf-endomorph-male.546c355a.svg";